import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';
import { MembershipCancelReason } from './MembershipCancelReasonsService';

const URL = '/v2/parent-membership-cancel';

export interface ParentMembershipCancelRequest {
  parentId: number;
  planId: number;
  reason: MembershipCancelReason;
  cancelText?: string;
}

class ParentMembershipCancelService {
  static create(
    data: ParentMembershipCancelRequest,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<unknown>> {
    return axios.post(URL, data, config);
  }
}

export { ParentMembershipCancelService };
